module.exports = __webpack_public_path__ + "img/logo.0ca0d543.png";